/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Badgeur } from '../../models/badgeur';

export interface GetBadgeur$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The Badgeur Uid.
 */
  badgeurUid: string;
}

export function getBadgeur(http: HttpClient, rootUrl: string, params: GetBadgeur$Params, context?: HttpContext): Observable<StrictHttpResponse<Badgeur>> {
  const rb = new RequestBuilder(rootUrl, getBadgeur.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('badgeurUid', params.badgeurUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Badgeur>;
    })
  );
}

getBadgeur.PATH = '/custom/stations/{uid}/badgeur/{badgeurUid}';
